import { styled } from "@mui/material/styles";
import { LinearProgress } from "@mui/material";
const CustomLinearProgress = styled(LinearProgress) `
  height: 8;
`;
export default CustomLinearProgress;
